import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    dialogActionsRoot: {
      margin: '14px'
    },
    root: {
      flexGrow: 1
      // backgroundColor: theme.palette.background.paper,
      // minHeight: '100vh',
      // '& *:focus': {
      //   outline: 'none !important'
      // }
    },
    title: {},

    appBar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(2)
    },

    resume: {
      '& > *': {
        display: 'table'
      },
      '& .MuiListItem-root #balance': {
        textAlign: 'center'
      }
    },
    positive: {
      color: theme.palette.primary.main
    },
    negative: {
      color: theme.palette.error.main
    },
    cardFooterButtons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  })
